export enum CommittedLoadStatus {
  Unknown = -1,
  AcceptedNotYetConnected = 0,
  QuotationSent = 1,
}

export type CommittedLoadConnection = {
  enquiryReference: number;
  date: string;
  importCapacitykVa: number;
  exportCapacitykW: number;
  status: CommittedLoadStatus;
};

export type CommittedLoad = {
  connections: CommittedLoadConnection[];
  totalConnections: number;
};

export interface IHasCommittedLoad {
  committedLoad: CommittedLoad;
}

export const CommittedLoadDefault: CommittedLoad = { connections: [], totalConnections: 0 };
